import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=d373b2ac&scoped=true"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d373b2ac",
  null
  
)

export default component.exports